export * from './kunden-gruppes-list.component';
export * from './kunden-gruppes-list.component.module';